import DataSheetPrintOptions from "csi/middleware/customView/options/DataSheetPrintOptions";
import DataSheetViewOptions from "csi/middleware/customView/options/DataSheetViewOptions";
import React, { FunctionComponent } from "react";
import SizeChartReviewDataSheetViewOptions from "./SizeChartReviewDataSheetViewOptions";

const SizeChartReviewDataSheetOptionsTab: FunctionComponent = function SizeChartReviewDataSheetOptionsTab() {
	return (
		<>
			<SizeChartReviewDataSheetViewOptions />
			<DataSheetViewOptions />
			<DataSheetPrintOptions />
		</>
	);
};

export = SizeChartReviewDataSheetOptionsTab;